import ACTIONS from '../actionTypes/publish'

const initialState = {
  isPublishing: false,
  allPlatforms: null,
  applicationReleasePlatforms: null,
  isFetchingAppReleasePlatforms: false,
  currentAppReleasePlatform: null,
  currentPlatformSettings: null,
  isFetchingPlatformSettings: false,
  isUpdatingPlatformSettings: false
}

const PublishReducer = (state = initialState, action) => {
  switch (action.type) {

    // publishToPlatforms
    case ACTIONS.START_PUBLISH_TO_PLATFORMS:
      return {
        ...state,
        isPublishing: true
      }
    case ACTIONS.PUBLISH_TO_PLATFORMS_SUCCESS:
      return {
        ...state,
        isPublishing: false
      }
    case ACTIONS.PUBLISH_TO_PLATFORMS_FAILED:
      return {
        ...state,
        isPublishing: false
      }

    // getApplicationReleasePlatforms
    case ACTIONS.START_GET_APPLICATION_RELEASE_PLATFORMS:
      return {
        ...state,
        isFetchingAppReleasePlatforms: true
      }
    case ACTIONS.GET_APPLICATION_RELEASE_PLATFORMS_SUCCESS:
      return {
        ...state,
        allPlatforms: action.payload?.platforms,
        applicationReleasePlatforms: action.payload?.applicationReleasePlatforms,
        isFetchingAppReleasePlatforms: false,
      }
    case ACTIONS.GET_APPLICATION_RELEASE_PLATFORMS_FAILED:
      return {
        ...state,
        isFetchingAppReleasePlatforms: false,
      }

    // getPlatformSettings
    case ACTIONS.START_GET_PLATFORM_SETTINGS:
      return {
        ...state,
        isFetchingPlatformSettings: true
      }
    case ACTIONS.GET_PLATFORM_SETTINGS_SUCCESS:
      return {
        ...state,
        currentAppReleasePlatform: action.payload,
        currentPlatformSettings: action.payload?.applicationPlatformSetting,
        isFetchingPlatformSettings: false,
      }
    case ACTIONS.GET_PLATFORM_SETTINGS_FAILED:
      return {
        ...state,
        isFetchingPlatformSettings: false,
      }

    // addOrUpdatePlatformSettings
    case ACTIONS.START_ADD_OR_UPDATE_PLATFORM_SETTINGS:
      return {
        ...state,
        isUpdatingPlatformSettings: true
      }
    case ACTIONS.ADD_OR_UPDATE_PLATFORM_SETTINGS_SUCCESS:
      return {
        ...state,
        currentAppReleasePlatform: action.payload,
        currentPlatformSettings: action.payload?.applicationPlatformSetting,
        isUpdatingPlatformSettings: false,
      }
    case ACTIONS.ADD_OR_UPDATE_PLATFORM_SETTINGS_FAILED:
      return {
        ...state,
        isUpdatingPlatformSettings: false,
      }

    // Default
    default:
      return state
  }
}

export default PublishReducer